/* eslint-disable no-nested-ternary */

import { useLocation } from 'react-router-dom'
import { ChevronDownIcon } from '../../assets/icons/chevron down'
import { LogoutIcon } from '../../assets/icons/logout'
import { MenuIcon } from '../../assets/icons/menu'
import Organization from '../../assets/icons/organization'
import { UserIcon } from '../../assets/icons/user'
import { UserWhite } from '../../assets/icons/userWhite'
import {
  Button,
  ConfigButtons,
  IconDown,
  Span,
  SpanLogout,
  SpanText,
  TopStyle,
  UserIconStyle,
  UserLog,
} from './Top.style'
import { TopUserData } from './TopUserData/TopUserData'
import { useOrganizationList } from '../OrganizationList/useOrganizationList'
import { useTopUserData } from './TopUserData/useTopUserData'
import { OrganizationList } from '../OrganizationList'
import { SettingTwoIcon } from '../../assets/icons/setting-two'
import { colors } from '../../theme'
import { ehRotaAdministrativa } from '../../utils/rotaAdministrativa'

// import { AuthContext } from '../../contexts/AuthContext/AuthContext'

// const Organizacoes = [
//   {
//     id: 1,
//     text: 'Linkcom Informatica Ltda',
//     header: 'linkcom',
//   },
//   {
//     id: 1,
//     text: 'Linkcom Informatica Ltda',
//     header: 'linkcom',
//   },
// ]

type TopProps = {
  bigMenu: () => void
  isBigMenu: boolean
}

export function Top({ bigMenu, isBigMenu }: TopProps) {
  const { useOrganizationsList } = useOrganizationList()
  const {
    userDataOrganization,
    userData,
    adm,
    isShowConfig,
    handleFiltroCliente,
    isOrganization,
    setIsOrganization,
    showConfig,
    handleValidaXtenantId,
    handleGuardaXtenantId,
  } = useTopUserData()

  const location = useLocation()
  const { pathname } = location

  // Regra por prefixo no lugar da lista fixa que estava aqui: a lista de segmentos
  // nunca recebeu 'adm-gestao-tenants', entao o Top gravava adm='' enquanto o usuario estava
  // naquela tela e um F5 ali derrubava a propria rota. Toda tela /adm-* nova repetia o bug.
  if (ehRotaAdministrativa(pathname)) {
    localStorage.setItem('adm', JSON.stringify('administrador'))
  } else {
    localStorage.setItem('adm', JSON.stringify(''))
  }

  return (
    <TopStyle isBigMenu={isBigMenu}>
      <Button type="button" onClick={bigMenu}>
        <MenuIcon />
      </Button>
      <UserLog>
        <UserIconStyle>
          <UserIcon />
        </UserIconStyle>
        <TopUserData />
        <IconDown onClick={showConfig}>
          <ChevronDownIcon />
        </IconDown>
      </UserLog>
      {isShowConfig ? (
        <ConfigButtons>
          {(userData?.papel === 'ADMINISTRADOR' && adm === 'administrador') ||
          (userData?.papel === 'USUARIO' &&
            userDataOrganization?.papelOrganizacao === 'ADMINISTRADOR' &&
            adm === 'administrador') ? (
            <Span>
              <Organization />
              <SpanText
                to="/dashboard"
                onClick={() => {
                  handleFiltroCliente('')
                  handleValidaXtenantId()
                }}
              >
                Cartivia
              </SpanText>
            </Span>
          ) : (
            ''
          )}
          {(userData?.papel === 'ADMINISTRADOR' && adm === '') ||
          (userData?.papel === 'USUARIO' &&
            userDataOrganization?.papelOrganizacao === 'ADMINISTRADOR' &&
            adm === '') ? (
            <Span>
              <UserWhite />
              <SpanText to="/editar&perfil" onClick={showConfig}>
                <p>{userData?.nome}</p>

                {userData?.email}
              </SpanText>
            </Span>
          ) : userData?.papel === 'USUARIO' && adm === '' ? (
            <Span>
              <UserWhite />
              <SpanText to="/editar&perfil" onClick={showConfig}>
                <p>{userData?.nome}</p>

                {userData?.email}
              </SpanText>
            </Span>
          ) : (
            ''
          )}
          {adm === '' &&
          useOrganizationsList != null &&
          useOrganizationsList.length > 1 ? (
            <Span>
              <Organization />
              <SpanText
                to=""
                onClick={() => {
                  setIsOrganization(true)
                  showConfig()
                }}
              >
                Trocar de organização
              </SpanText>
            </Span>
          ) : (
            ''
          )}
          {userData?.papel === 'ADMINISTRADOR' && adm === '' ? (
            <Span>
              <SettingTwoIcon color={colors.grey900} />
              <SpanText
                to="/admin"
                onClick={() => {
                  handleFiltroCliente('administrador')
                  showConfig()
                  handleGuardaXtenantId()
                  // handleAdm()
                }}
              >
                Administrativo
              </SpanText>
            </Span>
          ) : (
            ''
          )}
          <SpanLogout to="/logout">
            <LogoutIcon /> <SpanText to="/logout">Sair</SpanText>
          </SpanLogout>
        </ConfigButtons>
      ) : null}
      {isOrganization ? <OrganizationList /> : null}
    </TopStyle>
  )
}
